// extracted by mini-css-extract-plugin
export var linkText = "_mw-0";